class ShowMore {
  constructor() {
    this.init();
  }

  init() {
    const productGrids = document.querySelectorAll('.product-grid');
    productGrids.forEach(grid => {
      const products = grid.querySelectorAll('.grid__item');
      const mobileThreshold = parseInt(grid.dataset.mobileThreshold) || 4;
      const desktopThreshold = parseInt(grid.dataset.desktopThreshold) || 8;
      
      // Hide products beyond threshold initially
      products.forEach((product, index) => {
        if (window.innerWidth < 750) {
          if (index >= mobileThreshold) {
            product.style.display = 'none';
          }
        } else {
          if (index >= desktopThreshold) {
            product.style.display = 'none';
          }
        }
      });

      // Create and append show more button if needed
      if (products.length > (window.innerWidth < 750 ? mobileThreshold : desktopThreshold)) {
        const showMoreButton = document.createElement('button');
        showMoreButton.className = 'show-more-button button';
        showMoreButton.textContent = 'Show More';
        showMoreButton.addEventListener('click', () => this.handleShowMore(products, showMoreButton));
        grid.parentNode.appendChild(showMoreButton);
      }
    });

    // Handle window resize
    window.addEventListener('resize', () => {
      productGrids.forEach(grid => {
        const products = grid.querySelectorAll('.grid__item');
        const mobileThreshold = parseInt(grid.dataset.mobileThreshold) || 4;
        const desktopThreshold = parseInt(grid.dataset.desktopThreshold) || 8;
        const threshold = window.innerWidth < 750 ? mobileThreshold : desktopThreshold;
        
        products.forEach((product, index) => {
          if (index < threshold) {
            product.style.display = '';
          } else {
            product.style.display = 'none';
          }
        });

        const showMoreButton = grid.parentNode.querySelector('.show-more-button');
        if (showMoreButton) {
          showMoreButton.style.display = products.length > threshold ? '' : 'none';
        }
      });
    });
  }

  handleShowMore(products, button) {
    const isMobile = window.innerWidth < 750;
    const threshold = isMobile ? 
      parseInt(products[0].closest('.product-grid').dataset.mobileThreshold) || 4 :
      parseInt(products[0].closest('.product-grid').dataset.desktopThreshold) || 8;

    // Check if currently expanded
    const expanded = button.getAttribute('data-expanded') === 'true';
    if (!expanded) {
      // Show all products
      products.forEach(product => {
        product.style.display = '';
      });
      button.textContent = 'Show Less';
      button.setAttribute('data-expanded', 'true');
    } else {
      // Collapse to threshold
      products.forEach((product, index) => {
        if (index < threshold) {
          product.style.display = '';
        } else {
          product.style.display = 'none';
        }
      });
      button.textContent = 'Show More';
      button.setAttribute('data-expanded', 'false');
    }
  }
}

customElements.define('show-more', class extends HTMLElement {
  connectedCallback() {
    new ShowMore();
  }
});
